/* istanbul ignore file */
import { UiThemeOverrider } from 'framework/uiTheme';
import BigFormRow from '../FormRow/BigFormRow';

interface VerticalAddressInputLayoutProps {
  children: React.ReactElement;
}

const VerticalAddressInputLayout = ({ children }: VerticalAddressInputLayoutProps) => {
  return (
    <UiThemeOverrider
      overriddenLayouts={{
        AddressInputLayout: BigFormRow,
      }}
    >
      {children}
    </UiThemeOverrider>
  );
};

export default VerticalAddressInputLayout;
